import { FILTER_NAME_SUB_MENU } from '../../constants/filter'

export const DocumentPermissionGroup = {
  admin: 'admin',
  dweller: 'dweller',
  landlord: 'landlord',
  manager: 'manager',
}

export const DOCUMENT_USER_ACCESS_ROLE = {
  [DocumentPermissionGroup.admin]: 'Documents.RoleAccessAdminKey',
  [DocumentPermissionGroup.dweller]: 'Documents.RoleAccessDwellerKey',
  [DocumentPermissionGroup.landlord]: 'Documents.RoleAccessLandlordKey',
  [DocumentPermissionGroup.manager]: 'Documents.RoleAccessManagerKey',
}

export const DOCUMENT_ALL_PERMISSION_GROUPS = Object.keys(
  DOCUMENT_USER_ACCESS_ROLE
)

// Dwellers and landlords cannot open a contractor's documents, so the provider
// profile creates files and folders with this fixed access set and no access UI.
export const DOCUMENT_STAFF_PERMISSION_GROUPS = [
  DocumentPermissionGroup.admin,
  DocumentPermissionGroup.manager,
]

export const DOCUMENT_ACCESS_LEVEL = {
  allow: 'allow',
  deny: 'deny',
  readonly: 'readonly',
}

export const DOCUMENT_ACCESS_LEVEL_RANK = {
  [DOCUMENT_ACCESS_LEVEL.allow]: 2,
  [DOCUMENT_ACCESS_LEVEL.deny]: 0,
  [DOCUMENT_ACCESS_LEVEL.readonly]: 1,
}

export const DOCUMENT_ALL_PERMISSION_GROUPS_ALLOW = Object.fromEntries(
  DOCUMENT_ALL_PERMISSION_GROUPS.map(role => [
    role,
    DOCUMENT_ACCESS_LEVEL.allow,
  ])
)

export const DOCUMENT_FOLDER_FORM_NAME_FIELD_MAX_LENGTH = 256

export const QA_NAME_DOCUMENTS_TABLE = 'documents'

export const QA_NAME_DOCUMENTS_TABLE_ADD_NEW_FOLDER = 'addNewFolder'

export const QA_NAME_DOCUMENTS_TABLE_UPLOAD_NEW_DOCUMENT = 'uploadNewDocument'

export const DOCUMENTS_FILTER_KEY_PARENT = 'parent'

export const EXCLUDE_FILTERS = [
  FILTER_NAME_SUB_MENU,
  DOCUMENTS_FILTER_KEY_PARENT,
]

export const DOCUMENTS_ACTION_REMOVE = 'delete'

export const DOCUMENTS_ACTION_REMOVE_MASS = 'delete_mass'

export const DOCUMENTS_ACTION_DOWNLOAD = 'download'

export const DOCUMENTS_ACTION_EDIT = 'edit'

export const DOCUMENTS_ACTION_DOWNLOAD_MASS = 'download_mass'

export const DOCUMENTS_ACTION_SEND_VIA_EMAIL = 'send_via_email'

export const DOCUMENTS_ACTION_SEND_VIA_EMAIL_MASS = 'send_via_email_mass'

export const DOCUMENTS_ACTION_MOVE_TO = 'move'

export const DOCUMENTS_ACTION_MOVE_TO_MASS = 'move_mass'

export const DOCUMENTS_ACTION_EDIT_ACCESS = 'edit_access'

export const DOCUMENTS_ACTION_EDIT_ACCESS_MASS = 'edit_access_mass'

export const DOCUMENTS_ACTION_DUPLICATE = 'duplicate'

export const DOCUMENTS_ACTION_DUPLICATE_TO_RELATED = 'duplicate_to_related'

export const DOCUMENTS_ACTION_MARK_AS_INVOICE = 'mark_as_invoice'

export const DOCUMENTS_ACTION_MARK_AS_VULCAVO = 'mark_as_vulcavo'

export const DOCUMENTS_ACTION_VIEW_REPORT = 'view_report'

export const DOCUMENTS_MASS_ACTION_NAMES = {
  [DOCUMENTS_ACTION_DOWNLOAD]: 'download',
  [DOCUMENTS_ACTION_DOWNLOAD_MASS]: 'download',
  [DOCUMENTS_ACTION_EDIT_ACCESS_MASS]: 'edit_access',
  [DOCUMENTS_ACTION_MOVE_TO]: 'move',
  [DOCUMENTS_ACTION_MOVE_TO_MASS]: 'move',
  [DOCUMENTS_ACTION_REMOVE]: 'delete',
  [DOCUMENTS_ACTION_REMOVE_MASS]: 'delete',
}

export const DROP_TARGET_DATA_KEY = 'data-drop-target'
